"use strict";
// packages/shared-types/src/email-categories.ts
//
// Email categories used by the layered preference system. Role groups define
// defaults per category; users override individually. The CRITICAL_* list
// bypasses preferences entirely — those emails always send.
Object.defineProperty(exports, "__esModule", { value: true });
exports.CRITICAL_EMAIL_CATEGORIES = exports.STAFF_ONLY_EMAIL_CATEGORIES = exports.EMAIL_CATEGORY_LINES = exports.EMAIL_CATEGORY_KEYS = exports.EMAIL_CATEGORY_DESCRIPTIONS = exports.EMAIL_CATEGORIES = void 0;
exports.emailCategoryKeysForLine = emailCategoryKeysForLine;
exports.isCriticalCategory = isCriticalCategory;
exports.EMAIL_CATEGORIES = {
    productUpdates: 'Product Updates',
    inventoryAlerts: 'Inventory Alerts',
    salesActivity: 'Sales Activity',
    staffActivity: 'Staff Activity',
    customerActivity: 'Customer Activity',
    systemAlerts: 'System Alerts',
    weeklyReports: 'Weekly Reports',
    marketing: 'Marketing & Promos',
    webReadiness: 'Web Readiness',
    careers: 'Careers & Hiring',
    property: 'Property & Rent',
    salesLeads: 'Sales & Leads',
    rubyTokens: 'Ruby Tokens',
    documents: 'Documents & Inspections',
};
exports.EMAIL_CATEGORY_DESCRIPTIONS = {
    productUpdates: 'Product published, price changes, recipe updates',
    inventoryAlerts: 'GRN received, low stock, negative stock',
    salesActivity: 'Daily summaries, large transactions, voids',
    staffActivity: 'Clock in/out exceptions, time-off requests',
    customerActivity: 'New customers, loyalty milestones, age verification',
    systemAlerts: 'Failed jobs, integration errors',
    weeklyReports: 'Weekly digests across categories',
    marketing: 'Campaign results, promo performance',
    webReadiness: 'Web Readiness batches, item messages and replies, send-backs, flags, daily digest',
    careers: 'New job applications from your website',
    property: 'Rent due, lease updates, resident communications',
    salesLeads: 'New enquiries, demo reminders, won deals',
    rubyTokens: 'Monthly Ruby Tokens used up, additional usage limit reached',
    documents: 'Invoice ZIPs and emails sent from Documents, inspector access requests',
};
exports.EMAIL_CATEGORY_KEYS = Object.keys(exports.EMAIL_CATEGORIES);
/**
 * Categories that belong to ONE product line (final review B-I1). A category listed here is shown
 * in a business's notification settings only when the business runs that line; every other
 * category is shown to every business. The key itself stays in EMAIL_CATEGORIES -- emails keep
 * carrying it -- this only decides where the toggle is offered.
 */
exports.EMAIL_CATEGORY_LINES = {
    property: 'rubyestate',
};
/**
 * Categories for RubyTill's OWN team (and the prospects it writes to) — never
 * offered in a business's notification settings. Leads Desk spec §4.5.
 */
exports.STAFF_ONLY_EMAIL_CATEGORIES = new Set(['salesLeads']);
/** The categories a business on `productLine` should see, in catalogue order. Missing/unknown line ⇒ Ruby Till. */
function emailCategoryKeysForLine(productLine) {
    const line = productLine === 'rubyestate' ? 'rubyestate' : 'rubytill';
    return exports.EMAIL_CATEGORY_KEYS.filter(k => !exports.STAFF_ONLY_EMAIL_CATEGORIES.has(k) && (!exports.EMAIL_CATEGORY_LINES[k] || exports.EMAIL_CATEGORY_LINES[k] === line));
}
exports.CRITICAL_EMAIL_CATEGORIES = new Set([
    'auth',
    'billing',
    'security',
    'critical-operations',
    'legal',
]);
function isCriticalCategory(category) {
    return !!category && exports.CRITICAL_EMAIL_CATEGORIES.has(category);
}
//# sourceMappingURL=email-categories.js.map